import type { TicketBereich } from "./ticketTypen";

export type BereichTreffer = { bereich: TicketBereich; bezugTyp?: string; bezugId?: string; bezugLabel?: string };

/** Detailrouten mit Bezug (erste passende Regel gewinnt). */
const DETAIL: Array<{ muster: RegExp; bereich: TicketBereich; typ: string; label: string }> = [
  { muster: /^\/vorgaenge\/(?:v\d+\/)?(\d+)/, bereich: "vorgaenge", typ: "vorgang", label: "Vorgang" },
  { muster: /^\/todos\/(\d+)/, bereich: "vorgaenge", typ: "todo", label: "To-do" },
  { muster: /^\/contacts\/(\d+)/, bereich: "kontakte", typ: "kontakt", label: "Kontakt" },
  { muster: /^\/kontakte\/edit\/(\d+)/, bereich: "kontakte", typ: "kontakt", label: "Kontakt" },
  { muster: /^\/risks\/(\d+)/, bereich: "risiken", typ: "risiko", label: "Risiko" },
  { muster: /^\/risiken\/edit\/(\d+)/, bereich: "risiken", typ: "risiko", label: "Risiko" },
  { muster: /^\/contracts\/(\d+)/, bereich: "vertraege", typ: "vertrag", label: "Vertrag" },
  { muster: /^\/vertraege\/edit\/(\d+)/, bereich: "vertraege", typ: "vertrag", label: "Vertrag" },
  // Schäden haben keinen eigenen Bereich mehr — sie hängen an Verträgen; der Bezug bleibt erhalten.
  { muster: /^\/schaeden\/(?:edit\/)?(\d+)/, bereich: "vertraege", typ: "schaden", label: "Schaden" },
];

/**
 * Listen/Bereiche ohne Bezug (Präfix-Treffer, erste passende Regel gewinnt).
 * Mail, Termine, Chat und Telefonie (auch deren Einstellungen) sind
 * „Termine/Schriftverkehr/Telefonie“; alles Übrige ist „Allgemein“.
 */
const BEREICH: Array<[string[], TicketBereich]> = [
  [["/dashboard"], "dashboard"],
  [["/contacts", "/kontakte", "/kunde"], "kontakte"],
  [["/risks", "/risiken", "/risiko"], "risiken"],
  [["/contracts", "/vertraege", "/vertrag"], "vertraege"],
  [["/damages", "/schaeden", "/schaden-melden"], "vertraege"],
  [["/anrufe", "/einstellungen/telefonie", "/emails", "/termine", "/chat"], "kommunikation"],
  [["/vorgaenge", "/todos"], "vorgaenge"],
];

/** Sammelbereich für alles ohne eigenen Treffer. */
export const BEREICH_STANDARD: TicketBereich = "allgemein";

const passt = (pfad: string, praefix: string) => pfad === praefix || pfad.startsWith(`${praefix}/`);

export function bereichAusRoute(roh: string): BereichTreffer {
  const pfad = (roh || "/").split(/[?#]/)[0] || "/";
  if (pfad === "/") return { bereich: "dashboard" };
  for (const d of DETAIL) {
    const m = d.muster.exec(pfad);
    if (m) return { bereich: d.bereich, bezugTyp: d.typ, bezugId: m[1], bezugLabel: `${d.label} ${m[1]}` };
  }
  for (const [praefixe, bereich] of BEREICH) {
    if (praefixe.some((p) => passt(pfad, p))) return { bereich };
  }
  return { bereich: BEREICH_STANDARD };
}
